module.exports = __webpack_public_path__ + "img/sellodam.9bb6089f.jpg";